import { ID, idDef } from "@kosmod/kit";
import { s } from "@kosmod/pancake";
import { GameID } from "@kosmod/sesame";

export type AssetID = ID<"asset">;
export const AssetID = s.ref<AssetID>()(idDef);


export type AssetVersionID = ID<"asset-version">;
export const AssetVersionID = s.ref<AssetVersionID>()(idDef);

export type AssetMeta = {
  id: AssetID,
  gameId: GameID,

  status: 'not-started' | 'in-progress' | 'ready',

  contentType: string,
  contentLength: number,

  version: AssetVersionID,
  etag: string,
  lastModified: string,
}
export const AssetMeta = s.ref<AssetMeta>()(s.o({
  id: AssetID,
  gameId: GameID,

  status: s.lu(['not-started', 'in-progress', 'ready']),

  contentType: s.str,
  contentLength: s.num,

  version: AssetVersionID,
  etag: s.str,
  lastModified: s.str,
}));

/**
 * An asset reference can refer to a literal Asset, or a special
 * builtin reference for hardcoded assets
 */
export type AssetReference =
  | { type: 'none' }
  | { type: 'builtin', name: string }
  | { type: 'reference', id: AssetID }

export const AssetReference = s.ref<AssetReference>()(s.du('type', {
  'builtin': { name: s.str },
  'reference': { id: AssetID },
  'none': { }
}));
